import React from 'react';
import { Button, Typography } from '@one-thd/sui-atomic-components';
import { string as stringType } from 'prop-types';

const FallbackCard = ({
  header, subheader, footerUrl, footer, componentName
}) => {
  return (
    <div
    // eslint-disable-next-line tailwindcss/no-arbitrary-value
      className="sui-flex sui-flex-col sui-h-full sui-min-h-[350px]"
      data-type="container"
      data-component={`${componentName}FallbackCard`}
    >
      <div className="sui-flex sui-flex-col sui-gap-4">
        <Typography variant="body-base" weight="bold" height="tight">{header}</Typography>
        <Typography variant="body-base" weight="regular" height="tight">{subheader}</Typography>
      </div>
      <div className="sui-flex sui-flex-col sui-mt-auto">
        <Button
          href={footerUrl}
          fullWidth
          variant="secondary"
          role="button"
          tag="a"
        >
          {footer}
        </Button>
      </div>
    </div>

  );
};

FallbackCard.propTypes = {
  header: stringType,
  subheader: stringType,
  footerUrl: stringType,
  footer: stringType,
  componentName: stringType
};

FallbackCard.defaultProps = {
  header: null,
  subheader: null,
  footerUrl: null,
  footer: null,
  componentName: ''
};

export { FallbackCard };